<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!--        <div v-if="$gate.isSysAdmin()">-->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="row">
					<div class="col-lg-4">
						<div class="card card-danger">
							<div class="card-header">
								Vehicle Profile
							</div>
							<div class="card-body overflow-auto">
								{{vehicle.make}}
								{{vehicle.model}}
								{{vehicle.year}}
								{{vehicle.weight_capacity}}
								{{vehicle.status}}
								{{vehicle.notes}}
								{{vehicle.delivery_partner}}
							</div>
							<div class="card-footer">
								
							</div>
						</div>
					</div>
					<div class="col-lg-8">
						<div class="card card-danger ">
							<div class="card-header">
								Vehicle Documents
							</div>
							<div class="card-body overflow-auto">
								<table class="table table-striped table-bordered table-hover">
									<thead>
										<tr>
											<th scope="col">Doc. Name</th>
											<th scope="col">Doc. Number</th>
											<th scope="col">Front</th>
											<th scope="col">Back</th>
											<th scope="col">Notes</th>
											<th scope="col">Valid Till</th>
											<th scope="col">Validity</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="doc in vehicle.delivery_vehicle_documents">
											<td>{{doc.doc_name}}</td>
											<td>{{doc.doc_no}}</td>
											<td>{{doc.doc_front}}</td>
											<td>{{doc.doc_back}}</td>
											<td>{{doc.notes}}</td>
											<td>{{doc.valid_till}}</td>
											<td>{{doc.validity}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="card-footer">
								
							</div>
						</div>	
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<div class="card card-danger">
					<div class="card-body">
						<div class="form-group">
							<label>Doc Name</label>
							<input class="form-control" v-model="doc_name" placeholder="Enter the document name" type="text">
							<span class="badge badge-danger" v-if="errors.doc_name">Please enter a valid document name</span>
						</div>
						<div class="form-group">
							<label>Doc Number</label>
							<input class="form-control" v-model="doc_number" placeholder="Enter the document number" type="text">
							<span class="badge badge-danger" v-if="errors.doc_num">Please enter a valid document number</span>
						</div>
						<div class="form-group">
							<label>Front Image</label>
							<input class="form-control" placeholder="Add the front image" type="file" id="front" ref="front" @change="addFront">
							<span class="badge badge-danger" v-if="errors.front">Please upload a valid image</span>
						</div>
						<div class="form-group">
							<label>Back Image</label>
							<input class="form-control" placeholder="Add the back image" type="file" id="back" ref="back" @change="addBack">
							<span class="badge badge-danger" v-if="errors.back">Please upload a valid image</span>
						</div>
						<div class="form-group">
							<label>Notes</label>
							<input class="form-control" v-model="notes" placeholder="Enter notes" type="text">
							<span class="badge badge-danger" v-if="errors.notes">Please enter valid notes</span>
						</div>
						<div class="form-group">
							<label>Valid Till</label>
							<input class="form-control" v-model="valid_till" placeholder="Enter the valid till date" type="date">
							<span class="badge badge-danger" v-if="errors.valid_till">Please enter a valid date</span>
						</div>
						<div class="form-group">
							<button class="btn btn-primary" @click="addVehicleDocument">Submit</button>
						</div>
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
<!--        </div>-->
<!--        <div v-if="!$gate.isSysAdmin()">-->
<!--             <access-denied></access-denied>-->
<!--        </div>-->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getVehicle();
        },
        
        data(){
        	return {
        		vehicle: {},
        		errors: [],
        		doc_name: '',
        		doc_number: '',
        		notes: '',
        		valid_till: '',
        		front: '',
        		back: ''
        	}
        },
        
        methods: {
        	getVehicle(){
        		axios.post("/api/getVehicleProfile", {id: this.$route.params.id})
        		.then(response => {
        			this.vehicle = response.data;
        		})
        	},
        	
        	addFront(){
        		this.front = this.$refs.front.files[0];
        	},
        	
        	addBack(){
        		this.back = this.$refs.back.files[0];
        	},
        	
        	addVehicleDocument(){
        		var form = new FormData();
        		form.set("vehicle_id", this.vehicle.id);
        		form.set("dp_id", this.vehicle.delivery_partner.id);
        		form.set("doc_name", this.doc_name);
        		form.set("doc_no", this.doc_number);
        		form.set("notes", this.notes);
        		form.set("valid_till", this.valid_till);
        		form.append("front", this.front);
        		form.append("back", this.back);
        		axios({
        			method: 'post',
        			url: '/api/addVehicleDocument',
        			data: form
        		})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Document Added'
        			});
        			this.errors = [];
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		});
        	}
        }
    }
</script>
